import React, { useRef, useState, useEffect } from 'react';
import './ImageCarousel.css';
import Papa from "papaparse";

function ImageCarousel() {
  const [data, setData] = useState([]);

  // Sheet: https://docs.google.com/spreadsheets/d/1YxSpHk9Z0YAEOEgSbQm6fzESiAuUz7N9Bqf9ImQWkgM/edit#gid=0

  useEffect(() => {
    Papa.parse('https://docs.google.com/spreadsheets/d/e/2PACX-1vR-ZVX-X2XRIZCbnkCKL1TFuXJKCiC8u5rNPu_25jV3NnchQ4-dIqoERT4MUxiQhiRDlEcYdoA2a6Kq/pub?output=csv', {
      header: true,
      download: true,
      dynamicTyping: true,
      complete: (results) => {
        setData(results.data);
      }
    });
  }, []);


  const imgListRef = useRef(null);

  const scrollRight = () => {
    imgListRef.current.scrollBy({ left: 550, behavior: 'smooth' });
  };

  const scrollLeft = () => {
    imgListRef.current.scrollBy({ left: -550, behavior: 'smooth' });
  };


  return (
    <div className="image-carousel-container">

      {data.length ?
        <div className="image-carousel">
          <button className="image-carousel-btn" id="scroll-left" onClick={scrollLeft}>
            ❮
          </button>
          <ul className="imgList" ref={imgListRef}>
            {data.map((item, index) => {
              return (
                <li key={index} className="imgList-item">
                  <div className="image-container">
                    <a href={item.ArticleLink} target="_blank" rel="noreferrer">
                      <img
                        src={item.ImageLink}
                        alt="Recent Update"
                      />
                    </a>

                  </div>

                  <div className="image-item-caption">
                    <p>{item.Title}</p>
                  </div>
                </li>
              )
            })}


          </ul>
          <button className="image-carousel-btn" id="scroll-right" onClick={scrollRight}>
            ❯
          </button>
        </div>
        : <p className='Loading-tag'>Loading...</p>}
    </div>
  );
}

export default ImageCarousel;
